import { theme } from "../../theme";
export const analytics = {
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  contentWrapper: {
    height: "calc(100vh - 105px)",
    display: "flex",
    flexDirection: "column",
    // width: "74%", the width of the content part if we show the badge preview
    width: "100%",
  },
  topActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  topFilters: {
    paddingTop: "20px",
    paddingBottom: "20px",
  },
  userIcon: {
    position: "relative",
    top: "3px",
    marginRight: "7px",
    color: theme.palette.text.primary,
    fontSize: "18px",
  },
  listContent: {
    position: "relative",
    width: "100%",
    flexGrow: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    overflow: "auto",
  },

  mainDiv: { height: "calc(100vh - 700px)", width: "100%", minWidth: "460px" },
  innerDiv: { display: "flex", flexDirection: "column", height: "100%" },
  iconStyle: {
    position: "relative",
    color: theme.palette.grey[800],
    fontSize: "18px",
  },
  loadingDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "calc(100vh - 700px)",
    width: "100%",
    "& > div": {
      m: 0,
      height: "auto",
    },
  },
  centerDiv: {
    height: "100%",
    width: "100%",
    background: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  textFieldWithAdornment: {
    "& .input": {
      width: "100%",
      padding: "6px 30px 6px 7px",
    },
  },
  inputIcon: {
    position: "absolute",
    right: "7px",
    top: "50%",
    fontSize: "18px",
    color: theme.palette.grey["800"],
    cursor: "pointer",
  },
} as const;
